/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FeedSchedulerInput_org = {
    readonly id: string;
    readonly externalGroups?: {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "ExternalGroupList";
        readonly list: ReadonlyArray<{
            readonly email: string;
            readonly memberEmails: ReadonlyArray<string>;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    } | undefined;
    readonly teamForTeamId?: ({
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "Team";
        readonly teamId: string;
        readonly teamName: string;
        readonly teamMembers: ReadonlyArray<{
            readonly person: {
                readonly primaryCalendarId: string;
                readonly isYou: boolean;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            };
        }>;
        readonly invitedMembers: ReadonlyArray<{
            readonly person: {
                readonly primaryCalendarId: string;
                readonly isYou: boolean;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            };
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null | undefined;
    readonly " $refType": "FeedSchedulerInput_org";
};
export type FeedSchedulerInput_org$data = FeedSchedulerInput_org;
export type FeedSchedulerInput_org$key = {
    readonly " $data"?: FeedSchedulerInput_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FeedSchedulerInput_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v1 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isYou",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalImageUrl",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": [],
                "kind": "LocalArgument",
                "name": "emails"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "externalGroupRefetch"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "teamAttendeesRefetch"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "teamId"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "FeedSchedulerInput_org",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "condition": "externalGroupRefetch",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "emails",
                                "variableName": "emails"
                            }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "externalGroups",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExternalGroup",
                                        "kind": "LinkedField",
                                        "name": "list",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "email",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "memberEmails",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "ExternalGroupList",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ]
            },
            {
                "condition": "teamAttendeesRefetch",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "teamId",
                                "variableName": "teamId"
                            }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "teamForTeamId",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "teamMembers",
                                        "plural": true,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "invitedMembers",
                                        "plural": true,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "type": "Team",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '56cc059081654a86f6caa757aa5dc3c6';
export default node;
